import {useContext} from "react";
import {SessionNotificationContext} from "./../context";

export function useSessionNotifications() {
    return useContext(SessionNotificationContext);
}
